// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M98HJ8WfzKwDKo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 600px;
}
.M98HJ8WfzKwDKo > button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.M98HJ8WfzKwDKo div {
  display: block;
  height: 100%;
  text-align: center;
}
.M98HJ8WfzKwDKo div h4 {
  margin: var(--ds-space-250, 20px) var(--ds-space-200, 16px) var(--ds-space-300, 24px);
  font-size: 20px;
}
.M98HJ8WfzKwDKo div p {
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-200, 16px);
  font-size: 16px;
}
`, ""]);
// Exports
export var errorMessage = `M98HJ8WfzKwDKo`;
export default ___CSS_LOADER_EXPORT___;
